import * as Yup from "yup";

export const newsletterFormValidation = Yup.object().shape({
  email: Yup.string().email("You need to enter a valid email")
    .required("You need to enter your email - it will be used as your username"),
})
